export const breakoutRoomSpeakerSchema = `
  id
  givenName
  familyName
  coverImage
  jobTitle
`;
